import {blockMeta} from '../meta'

export const meta = blockMeta({
  name: 'global',
  defaultConfig: undefined,
  displayName: 'GlobalBlock',
  title: 'Global', // just for storybook
})
